module.exports = __webpack_public_path__ + "static/media/lemon.9b21d98d.png";